import React from "react";
import glamorous from "glamorous";

import {
  PanelContainer,
  Panel
} from "../../vendor/signal-widgets/components/panel";
import Colors from "../../styles/colors";

import {
  iconForExceptionType,
  textColorForExceptionType
} from "../exceptions/ExceptionLink";

const EventRow = props => {
  const { id, shipment, eventType, eventNum, pushShipmentDetailView } = props;

  let icon = iconForExceptionType(eventType);
  let iconColor = textColorForExceptionType(eventType);

  return (
    <glamorous.Div
      onClick={() => pushShipmentDetailView(id)}
      css={{
        padding: "1em",
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        backgroundColor: eventNum % 2 ? "#fff" : "#f5f5f5",
        ":hover": { cursor: "pointer", backgroundColor: "#eee" }
      }}
    >
      <glamorous.Div
        css={{
          color: iconColor,
          fontSize: "x-large",
          display: "flex",
          alignItems: "flex-start",
          marginRight: "0.25em"
        }}
      >
        {icon}
      </glamorous.Div>
      <glamorous.Div
        css={{ fontWeight: "bold", display: "flex", flexDirection: "column" }}
      >
        {`Shipment ${shipment}`}
        <glamorous.Div css={{ fontWeight: "normal", color: "#999" }}>
          {eventType}
        </glamorous.Div>
      </glamorous.Div>
    </glamorous.Div>
  );
};

export default class EventsList extends React.Component {
  componentDidMount() {
    const {
      fetchEvents,
      shipments,
      extractEventsFromShipments,
      clearEvents
    } = this.props;

    // Clear any existing events in our state
    clearEvents();

    // If a list of shipments was passed to us
    // we will extract the events from those shipments
    // otherwise, we will fetch all recent events
    if (shipments) {
      extractEventsFromShipments(shipments);
    } else {
      fetchEvents();
    }
  }

  componentWillReceiveProps(nextProps) {
    const { extractEventsFromShipments } = this.props;

    if (this.props.shipments) {
      if (this.props.shipments.length !== nextProps.shipments.length) {
        extractEventsFromShipments(nextProps.shipments);
      }
    }
  }

  render() {
    const { events, pushShipmentDetailView } = this.props;

    const eventRows = events.map((e, i) => (
      <EventRow
        key={i}
        eventNum={i}
        id={e.shipment_id}
        shipment={e.shipment}
        eventType={e.type}
        pushShipmentDetailView={pushShipmentDetailView}
      />
    ));

    return (
      <PanelContainer
        style={{
          marginLeft: 0,
          minWidth: "18em",
          maxWidth: "20em",
          maxHeight: "calc(100vh - 9em)",
          ...this.props.style
        }}
      >
        <Panel
          title="My Recent Events"
          canMaximize={false}
          style={{ border: "none" }}
          headerStyle={{
            color: Colors.background.DARK_BLUE
          }}
        >
          <glamorous.Div
            css={{
              height: "100%",
              overflow: "scroll",
              WebkitOverflowScrolling: "touch"
            }}
          >
            {eventRows}
          </glamorous.Div>
        </Panel>
      </PanelContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/events/EventsList.js